import React from 'react';
import PropTypes from 'prop-types';
import AppSwitcher from '../AppSwitcher';

const Layout = ({ children }) => (
  <div>
    <AppSwitcher />
    {children}
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
